import React from "react";
import { cn } from "@/utils/cn";

export type SectionHeaderTheme = "light" | "dark";
export type SectionHeaderAlign = "center" | "left";

export type SectionHeaderProps = {
  label: string;
  heading: React.ReactNode;
  description?: string;
  theme?: SectionHeaderTheme;
  align?: SectionHeaderAlign;
  className?: string;
  labelClassName?: string;
  headingClassName?: string;
};

const LABEL_COLOR: Record<SectionHeaderTheme, string> = {
  light: "text-primary-500",
  dark: "text-white",
};

const TEXT_COLOR: Record<SectionHeaderTheme, string> = {
  light: "text-black",
  dark: "text-white",
};

const ALIGN_CLASSES: Record<SectionHeaderAlign, string> = {
  center: "items-center text-center xl:mx-auto xl:max-w-282",
  left: "items-start text-left",
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  label,
  heading,
  description,
  theme = "light",
  align = "center",
  className,
  labelClassName,
  headingClassName,
}) => (
  <div
    className={cn(
      "flex flex-col gap-4 md:gap-6",
      ALIGN_CLASSES[align],
      className
    )}
  >
    <p
      className={cn(
        "caption-bold uppercase",
        LABEL_COLOR[theme],
        labelClassName
      )}
    >
      {label}
    </p>
    <h2
      className={cn(
        "headline-d-extrabold md:headline-c-extrabold",
        TEXT_COLOR[theme],
        headingClassName
      )}
    >
      {heading}
    </h2>
    {description && (
      <p
        className={cn(
          "body-a-regular md:subtitle-b-regular max-w-282",
          TEXT_COLOR[theme]
        )}
      >
        {description}
      </p>
    )}
  </div>
);
